"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingStep = void 0;
const HodOnboardingStepId_1 = require("../HodOnboardingStepId");
const BaseUserOnboardingStep_1 = require("../../../common/domain/BaseUserOnboardingStep");
const MeetingPreference_1 = require("./MeetingPreference");
const validator_1 = require("@leavy/validator");
class MeetingStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = HodOnboardingStepId_1.HodOnboardingStepId.HOD_MEETING;
    }
    getDataConstructor() {
        return MeetingPreference_1.MeetingPreference;
    }
    getDefaultData() {
        return new MeetingPreference_1.MeetingPreference();
    }
}
__decorate([
    (0, validator_1.Type)(() => MeetingPreference_1.MeetingPreference),
    __metadata("design:type", MeetingPreference_1.MeetingPreference)
], MeetingStep.prototype, "data", void 0);
exports.MeetingStep = MeetingStep;
//# sourceMappingURL=MeetingStep.js.map